import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
import { beforeItems, afterItems } from '../data/content';
export function BeforeAfter() {
  return <section className="bg-canvas px-5 py-16 sm:py-24" aria-labelledby="before-after-title" data-id="element-45" data-mp="3ogauvp93qz4s">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="3sgtonouk2f9m">
        <h2 id="before-after-title" className="text-center font-display text-3xl font-bold uppercase leading-tight text-navy-900 sm:text-5xl" data-id="element-47" data-mp="3sfs1wn46g4c2">
          From an implant dentist who wonders <span className="text-alert-deep" data-id="element-48" data-mp="3jhzm7hujmuo5">"Is this normal?"</span>
          <span className="mt-2 block text-radar-deep" data-id="element-49" data-mp="34stltqjyyyeo">To a professional who knows what to watch for.</span>
        </h2>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-50" data-mp="39remfr34vk3n">
          <div className="rounded-3xl border-2 border-alert/25 bg-white p-6 sm:p-8" data-id="element-51" data-mp="2vqkfzdznbt7m">
            <p className="inline-flex items-center gap-2 rounded-full bg-alert px-4 py-1.5 font-display text-lg font-bold uppercase tracking-wider text-white" data-id="element-52" data-mp="30pxcyrk8egnx">
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-53" data-mp="x2qwbitjt9xr" />
              Before
            </p>
            <ul className="mt-6 space-y-4" data-id="element-54" data-mp="t2p4s2hj1ww7">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-55" data-mp="1727zntlbvbqk">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-alert-light" data-id="element-56" data-mp="12355532z4nwu">
                    <XIcon className="h-4 w-4 text-alert-deep" strokeWidth={3} aria-hidden="true" data-id="element-57" data-mp="ef40i58x1rmp" />
                  </span>
                  <span className="text-[17px] leading-snug text-ink" data-id="element-58" data-mp="9gsr1vmj9j50">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy-900 p-6 ring-2 ring-radar sm:p-8" data-id="element-59" data-mp="jcnfj7dfu8fp">
            <p className="inline-flex items-center gap-2 rounded-full bg-radar px-4 py-1.5 font-display text-lg font-bold uppercase tracking-wider text-navy-950" data-id="element-60" data-mp="3rsyzp3wrh0ep">
              <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-61" data-mp="3mtm1xo4cq8xc" />
              With Implant Risk Radar™
            </p>
            <ul className="mt-6 space-y-4" data-id="element-62" data-mp="1qowstjg1046v">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-63" data-mp="1vnpwyl9faiud">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-radar" data-id="element-64" data-mp="20gapzkki8rwu">
                    <CheckIcon className="h-4 w-4 text-navy-950" strokeWidth={3} aria-hidden="true" data-id="element-65" data-mp="24gumclx97rhx" />
                  </span>
                  <span className="text-[17px] font-medium leading-snug text-white" data-id="element-66" data-mp="17tybwd42dn50">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-2xl space-y-4 text-center text-lg leading-relaxed text-ink" data-id="element-67" data-mp="1gr094390w0x5">
          <p data-id="element-68" data-mp="1lsxyzgbxhtz2">I can't promise that complications will never happen. No responsible clinician can.</p>
          <p data-id="element-69" data-mp="2s7gro5fvixo8">What I can give you is something much more useful:</p>
          <p className="font-display text-2xl font-semibold uppercase leading-snug text-navy-900" data-id="element-70" data-mp="2x60cu3mn85fj">
            A structured system for recognizing potential warning signs earlier.
          </p>
        </div>

        <SectionCta label="I want the Implant Risk Radar™ system" data-id="element-71" data-mp="32cou5k4z3266" />
      </div>
    </section>;
}